module.exports = __webpack_public_path__ + "static/media/image.b56f6743.svg";